module.exports = __webpack_public_path__ + "static/media/person8.d9f0b9b4.jpg";